module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001#pt001"
    }
  }, [_vm._v("PRELIMINARIES ON PHILOSOPHY AND FAITH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Blessings of Philosophy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Philosophy and Scripture")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Faith and Religion")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Kings and Priests")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Need for God")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Wired for God")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt1",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("GOD")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Triune God")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Talking about God and Knowing God")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Divine Attributes (I): Perfection, Necessity, and Self-Sufficiency")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Divine Attributes (II): God and Time, Omniscience, and Human Freedom")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Attributes of God (III): Omnipresence, Incorporeality, Beauty, Omnipotence")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Attributes of God (IV): Immutability, Impassibility, Simplicity (?), Humility")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-013"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The God of Truth (I): Truth on the Decline")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The God of Truth (II): The Inescapability of Truth")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("CREATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Moving toward God: Reasoning, Imagining, Seeking")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("God—the Best Explanation (I): The Problems with Naturalism")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("God—the Best Explanation (II): The Naturalists Are Declaring the Glory of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Reasons for God (I): God as the Cause of the Universe")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Reasons for God (II): God as the Designer of the Universe")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Reasons for God (III): God as the Source of Goodness")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Science, Nature, and God")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022#ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Miracles")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part004#pt004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("FALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023#ch023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Problem of Evil (I): Introductory Matters")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024#ch024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Problem of Evil (II): Evils Logical and Probabilistic")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025#ch025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Problem of Evil (III): Evils Natural and Demonic")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026#ch026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Primal Sin")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter027#ch027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Original Sin")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter028#ch028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Hell")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part005#pt005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("REDEMPTION AND RE-CREATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter029#ch029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Incarnation")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter030#ch030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Cross of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter031#ch031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Jesus’s Uniqueness and the Plurality of Religions")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-032"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter032#ch032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Body, Soul, and Immortality")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "aft"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/afterword#aft",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "dis"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter001#dis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "note"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0